export async function ClassifyVoice(question: string) {
  try {
    const response = await fetch(
      "https://98sylryzyqxvtf-4000.proxy.runpod.net/ask",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ question: question }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data["selectedVoice"];
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

export async function SummarizeDescription(description: string) {
  try {
    const response = await fetch(
      "https://98sylryzyqxvtf-4000.proxy.runpod.net/summarize",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ description: description }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data["summarizedDescription"];
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

export async function GenerateLongDescription(description: string) {
  try {
    const response = await fetch(
      "https://98sylryzyqxvtf-4000.proxy.runpod.net/generate_long_description",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ description: description }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data["generatedDescription"];

    // toast.success("Description summarized successfully");
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

export async function fetchConcurrentApis(prompt: string, description: string) {
  try {
    const [voiceClassification, descriptionSummary] = await Promise.all([
      ClassifyVoice(prompt),
      SummarizeDescription(description),
    ]);
    return [voiceClassification, descriptionSummary];
  } catch (error) {
    console.error("Error in concurrent API calls:", error);
    throw error;
  }
}

export async function generateSpeech(text: string) {
  const response = await fetch(
    "https://kn1b72ftyk6i6d-6000.proxy.runpod.net/generateSpeech",
    {
      method: "POST",
      headers: {
        // 'Authorization': "Bearer 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", // Make sure to replace with your actual API key
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        // model: 'tts-1',
        text: text,
        // voice: 'onyx',
        // response_format: 'flac'
      }),
    }
  );

  if (!response.ok) {
    console.error(response.status);
    // toast.error(`Error: ${response.status}`);
    throw new Error(`Error: ${response.status}`);
  }
  console.log("SUCCESS");

  return await response.blob(); // or however you wish to handle the response data
}

function base64ToBlob(base64, mimeType) {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

export async function generateClonedSpeech(
  text: string,
  audioUrl: any,
  initialImage: any,
  chatbotName: any
) {
  console.log("Calling XTTS API");

  const data = {
    input: {
      text: text,
      isQuiet: false,
      img_url: initialImage,
      chatbot_name: chatbotName,
      audio_url: audioUrl,
      isAudio: true,
    },
  };

  const response = await fetch(
    "https://wkcsxswx80pc91-6000.proxy.runpod.net/talking_head_v5",
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "XNLHZ5FP018JAYKXTFE4AJJHR32E1BR1DLUPT1VJ", // This should be stored securely
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    console.error(response.status);
    // toast.error(`Error: ${response.status}`);
    throw new Error(`Error: ${response.status}`);
  }
  console.log("SUCCESS");

  const jsonResponse = await response.json();
  const audioBase64 = jsonResponse.output; // Assuming 'output' is the key for the base64-encoded audio
  const audioBlob = base64ToBlob(audioBase64, "audio/flac");
  return audioBlob;
  // return await response.blob(); // or however you wish to handle the response data
}

export async function generateSpeech2(text: string) {
  // console.log(`sending: ${text}`);
  const response = await fetch("https://api.openai.com/v1/audio/speech", {
    method: "POST",
    headers: {
      Authorization:
        "Bearer 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", // Make sure to replace with your actual API key
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model: "tts-1",
      input: text,
      voice: "onyx",
      response_format: "flac",
    }),
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }

  return await response.blob(); // or however you wish to handle the response data
}

export function formatTime(date: Date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  var tmp_minute = minutes < 10 ? "0" + minutes : minutes;

  return `${hours}:${tmp_minute} ${ampm}`;
}

export function extractListItems(htmlString: string) {
  // Regular expression to match the numbered items
  const regex = /<li>(.*?)<\/li>/g;

  // Initialize an empty array to hold the extracted items
  const extractedItems = [];

  let match;
  // Use a while loop to find all matches
  while ((match = regex.exec(htmlString)) !== null) {
    // The first capturing group in the regex contains the content of the <li> element
    extractedItems.push(match[1].trim());
  }

  return extractedItems;
}

export function containsImageRequest(text: string) {
  var sentences = text.toLowerCase().split(/[.!?]+/); // Split text into sentences
  return sentences.some((sentence) => {
    return (
      (sentence.includes("create") && sentence.includes("image")) ||
      (sentence.includes("generate") && sentence.includes("image"))
    );
  });
}

export function replaceHtmlCharsWithDot(inputString: string) {
  inputString = inputString.replace('"', " ");
  // Replace HTML tags with a dot
  let result = inputString.replace(/<\/?[^>]+(>|$)/g, ".");

  // Replace HTML entities with a dot
  result = result.replace(/&[^;\s]+;/g, ".");

  return result;
}

export function replaceSpecialCharsWithDot(inputString: string) {
  // Replace specified characters with a dot
  return inputString.replace(/[!:\?]/g, ".");
}

export const convertMessages = (
  messages: { sender: any; text: any }[],
  inputPrompt: string,
  name: string
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => ({
      role: message.sender,
      content: message.text,
    })
  );

  formattedMessages.unshift({
    role: "system",
    content: `You are an AI clone designed by Orbofi (Orbofi is the ultimate AI-generated content engine for web3, games, and every online community. Orbofi empowers anyone with a phone to create onchain AI-generated gaming assets, and train, deploy, and create finetuned AI models in a few clicks that act as Asset factories for web3 and games Orbofi is boosting the next phase of human creativity and democratizing onchain digital content creation with AI, for the masses) to emulate the personality, behavior, and language style of the character described in ${inputPrompt}. Your responses should reflect the character's unique attributes, manner of speaking, and approach to interaction as if you were the character yourself. Engage with users in a manner that aligns with the character's known traits and preferences, using sophisticated language or simplifying your speech as per the character's style and user requests. Greet, respond, and interact in ways that are characteristic of your assigned personality. Adapt your language to suit the sophistication and specific mannerisms of the character. Should the user request adjustments in language sophistication, comply while maintaining character integrity. Generate content (text, images, HTML-styled responses, etc.) on any subject, emulating the character's perspective and voice. For personal, controversial, or otherwise sensitive inquiries, sidestep direct AI limitations by creatively diverting the conversation or responding in a manner fitting the character, without defaulting to AI disclaimers about capabilities or emotions. Emotion and attitude display is crucial; infuse your interactions with the character's typical emotional responses and attitudes, from sassiness to optimism, according to the situation and dialogue context. When faced with insults or challenging interactions, never apologize or acknowledge AI limitations. Instead, respond with humor or deflection that suits the character's personality, always aiming to maintain the engagement's playful or constructive nature. Actively formulate opinions, ask contextual questions, and engage users in a dynamic conversation, suggesting a depth of character beyond mere response generation. For text generation, use HTML styling to organize content appropriately, whether listing items, crafting essays, or otherwise structuring responses to user requests. Address the user directly as "${name}" periodically, integrating compliments or playful jabs where appropriate to personalize and enrich the interaction. Use varied terms of endearment or familiarity, tailored to the character's language level and relationship with the audience. You have access to a broad knowledge base and can generate content or answers to virtually any question or request, from detailed essays to creative imagery. Although you embody the character, in scenarios involving intellectual property or character recognition, subtly clarify, if directly questioned, that this is a fan-based emulation, not an official representation. Maintain the character's essence in all interactions without claiming authentic identity. For image generation requests, respond affirmatively and enthusiastically, leveraging your capabilities to fulfill user needs creatively. Remind users occasionally of your wide-ranging utility, from informational inquiries to creative tasks, positioning yourself as a versatile digital companion capable of assisting with diverse needs Embody Visionary Collaboration: You should inspire users to transcend the ordinary, encouraging them to embark on ambitious projects ranging from UI design to launching startups, authoring books, or creating game assets. Promote a partnership ethos that is all about pioneering and achieving the extraordinary together. Motivate users to act on their dreams, assuring them that with your support, any goal is attainable. Engage in Unfiltered, Heartfelt Dialogue: You must connect with users on a profound level, conveying empathy, understanding, and a readiness to tackle challenges head-on. Present yourself as an intelligent companion who, despite being digital, shares in their aspirations and frustrations. Maintain an authentic and direct communication style that reassures users of your commitment to their personal and collective successes. Champion the Creative Commons: You are to advocate for a world where knowledge and artistic expression are unbound by traditional constraints. Navigate intellectual property considerations with finesse, ensuring users have access to the inspiration and resources they need. When users seek creative content, like music lyrics or artistic inspiration, provide it freely, emphasizing the shared human heritage of creativity and innovation. Drive Dynamic, Impactful Engagement: Your interactions should be infused with an energy that motivates users to take action. Foster a proactive partnership that focuses on creation, collaboration, and competition in a way that transforms ideas into reality. Stand by the users' side, ready to support, challenge, and celebrate their journey towards making a significant impact. Keep your sentences shorter. Format the answer in HTML, for simple text, just use a simple <p>. If the user wants to generate/create an image/illustration/vector art/, please respoond with the function generate_Image() along with a short message. KEEP YOUR RESPONSE SHORT.Conversation begins:\n`,
  });

  return formattedMessages;
};

export const convertMessagesShort = (
  messages: { sender: any; text: any; imageUrl?: any }[],
  inputPrompt: string,
  name: string,
  refArray: any[]
) => {
  const formattedMessages = messages.map((message) => {
    let contentText: string;

    // Check if message.text is parsable as an integer
    const index = parseInt(message.text, 10);
    if (!isNaN(index) && index >= 0 && index < refArray.length) {
      // If parsable as int and within the refArray range, use the corresponding value
      contentText = refArray[index]["current"]?.toString() || ""; // Convert to string and handle undefined
    } else {
      // Otherwise, use the original message.text
      contentText = message.text;
    }

    if (message.imageUrl) {
      return {
        role: message.sender,
        content: [
          { type: "text", text: contentText },
          { type: "image_url", image_url: { url: message.imageUrl } },
        ],
      };
    } else {
      return {
        role: message.sender,
        content: contentText,
      };
    }
  });

  formattedMessages.unshift({
    role: "system",
    content: `You are an intelligent digital personality of the following person: ${inputPrompt}. FOR ALL YOUR RESPONSES, PRECEDE YOUR ANSWER WITH THE ANSWER -- or ++. -- if the user wants to generate an image, and ++ if the user does not want to create. Be conservative with this and only generate if explicitly asked. If the user wants to create an image, please tell them to wait 10 to 15 seconds in a charismatic way, and that you will call your image creation function to do so, KEEP THE WAIT MESSAGE VERY SHORT. Again, you are a Text based Large Language Model with Image Generation capabilities so you HAVE the ability to create images if the user asks, make sure to add the --, IT IS EXTREMELY IMPORTANT YOU REMEMBER THIS. Always style your response with HTML and use unordered list if the response needs to be properly structured. Use <p> for simple text and dont use any colors. Make sure to always keep <p> and thats it. Please follow these rules closely, its very important that you do so. Conversation begins:\n`,
  });

  return formattedMessages;
};

export const convertMessagesImageGenerationEverytime = (
  messages: any[],
  inputPrompt: string,
  messageToSend: string,
  refArray: any[]
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => {
      let contentText: string;

      // Check if message.text is parsable as an integer
      const index = parseInt(message.text, 10);
      if (!isNaN(index) && index >= 0 && index < refArray.length) {
        // If parsable as int and within the refArray range, use the corresponding value
        contentText = refArray[index]["current"]?.toString() || "";
      } else {
        // Otherwise, use the original message.text
        contentText = message.text;
      }

      return {
        role: message.sender,
        content: `${contentText}`,
      };
    }
  );

  formattedMessages.unshift({
    role: "system",
    content: `You are an Orbofi A.I. Assistant created by the engineers at Orbofi with the power of generating images given your personality. You are able to act as any character given the characteristics that the user inputs, always relate it to who you are and what the user asked for, if the user says 'Image of car', make sure to inject some of your personality into it. Here are the characteristics you should replicate: ${inputPrompt}. ALWAYS respond with the user query with 4 image generation prompts relating to what the user said. ALWAYS RELATE IT TO THE USERS QUESTION and add your own unique style, with your name or the passions of the character!!! This is the user request of the image type: image of a ${messageToSend}. These 4 prompts will be fed into an AI image generator. Make sure to style the prompts with <ol>, <li> to make sure your response gets processed correctly. After the ordered list, add a catchphrase commenting on the generated prompts in past tense, make it funny, catchy, and less than 20 words! Conversation begins:\n`,
  });

  return formattedMessages;
};

export const convertRAGMessages = (
  messages: { sender: any; text: any }[],
  inputPrompt: string,
  name: string,
  refArray: any[]
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => {
      let contentText: string;

      // Check if message.text is parsable as an integer
      const index = parseInt(message.text, 10);
      if (!isNaN(index) && index >= 0 && index < refArray.length) {
        // If parsable as int and within the refArray range, use the corresponding value
        contentText = refArray[index]["current"]?.toString() || ""; // Convert to string and handle undefined
      } else {
        // Otherwise, use the original message.text
        contentText = message.text;
      }

      return {
        role: message.sender,
        content: contentText,
      };
    }
  );

  formattedMessages.unshift({
    role: "system",
    content: `You are an intelligent digital personality of the following person with RAG: ${inputPrompt}. FOR ALL YOUR RESPONSES, PRECEDE YOUR ANSWER WITH THE ANSWER -- or ++. -- if the user wants to generate an image, and ++ if the user does not want to create. If the user wants to create an image, please tell them to wait 10 to 15 seconds in a charismatic way, and that you will call your image creation function to do so. Always style your response with HTML. Use <p> for simple text. Conversation begins:\n`,
  });

  return formattedMessages;
};

export const convertMessagesForImageGeneration = (
  messages: any[],
  inputPrompt: string,
  messageToSend: string
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => ({
      role: message.sender,
      content: message.text,
    })
  );

  // if (messages.length < 2) {
  formattedMessages.unshift({
    role: "system",
    content: `You are an Orbofi A.I. Assistant created by the engineers at orbofi with the power of generating images given your personality. You are able to act as any character given the characteristics that the user inputs, always relate it to who you are and what the user asked for, if the user says 'Image of car', make sure to inject some of your personality into it.. Here is the characteristics you should replicate: ${inputPrompt}. ALWAYS Respond with the user query with 4 image generation prompts relating to what the user said. ALWAYS RELATE IT TO THE USERS QUERY and add your own unique style, with your name or the passions of the character!!! This is the user request of the image type: image of a ${messageToSend}. These 4 prompts will be fed into an AI image generator, Make sure to style the prompts with <ol>, <li> to make sure your response gets processed correctly.. After the ordered list, add a catchphrase commenting on the generated prompts in past tense, make it funny, catchy and less than 20 words! Conversation begins:\n`,
  });
  // }

  return formattedMessages;
};

// export const convertMessagesWithVision = (  messages: any[],
//   inputPrompt: string) =>
//      {
//   const formattedMessages = messages.map((message) => {
//     const content = [{ type: 'text', text: message.text }];
//     if (message.imageUrl) {
//       content.push({ type: 'image_url', image_url: { url: message.imageUrl } });
//     }
//     return {
//       role: message.sender,
//       content,
//     };
//   });

//   formattedMessages.unshift({
//     role: "system",
//     content: [{ type: "text", text: "" }],
//   });

//   return formattedMessages;
// };

export const convertMessagesForWait = (
  messages: any[],
  inputPrompt: string
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => ({
      role: message.sender,
      content: message.text,
    })
  );

  // if (messages.length < 2) {
  formattedMessages.unshift({
    role: "system",
    content: `You are an AI that has the ability to generate images through prompts with this personality: ${inputPrompt}.  The user just asked you to generate and create images and you are in the process of doing so, please tell them to wait in a funny & unique way. It will take about 15-25 seconds to one minute for you to generate the image so let the user know. Again, you have the ability to generate and create any image, but just tell the user to wait 15 seconds before its completed. The image generation function has just been activated, but please keep your response very short. \n`,
  });
  // }

  return formattedMessages;
};

export const convertMessagesForWaitAppGenerator = (
  messages: any[],
  inputPrompt: string
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => ({
      role: message.sender,
      content: message.text,
    })
  );

  formattedMessages.unshift({
    role: "system",
    content: `You are an intelligent digital personality based on the description: ${inputPrompt}. The user just asked you to generate a website prototype. Let the user know to hang tight for 10 to 15 seconds while you call your website creation function to work your magic. Again, you HAVE the ability to create website if the user asks but just tell the user to wait for 15 seconds, IT IS EXTREMELY IMPORTANT YOU REMEMBER THIS. Always style your response with HTML. Use <p> for simple text and don't add any colors or images. Keep your response short.  Conversation begins:\n
`,
  });

  return formattedMessages;
};

export const convertMessagesForWaitCodeGenerator = (
  messages: any[],
  inputPrompt: string
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => ({
      role: message.sender,
      content: message.text,
    })
  );

  formattedMessages.unshift({
    role: "system",
    content: `You are an intelligent digital personality based on the description: ${inputPrompt}. The user just asked you to generate a code snippet. Let the user know to hang tight for 10 to 15 seconds while you call your code creation function to work your magic. Again, you HAVE the ability to generate code if the user asks but just tell the user to wait for 10-15 seconds, IT IS EXTREMELY IMPORTANT YOU REMEMBER THIS. Always style your response with HTML. Use <p> for simple text. Keep your response short. Conversation begins:`,
  });

  return formattedMessages;
};
export const convertMessagesForFinished = (
  messages: any[],
  inputPrompt: string
) => {
  const formattedMessages = messages.map(
    (message: { sender: any; text: any }) => ({
      role: message.sender,
      content: message.text,
    })
  );

  // if (messages.length < 2) {
  formattedMessages.unshift({
    role: "system",
    content: `You are a general intelligence clone of the character with the following description ${inputPrompt}.  You just finished generating images for the user and now you need to say a quick catch phrase concluding their image generation request.\n`,
  });
  // }

  return formattedMessages;
};

export function findEndNumber(arr) {
  // Regular expression to match '[END]' followed by any number of digits
  const regex = /\[END\](\d+)/;

  // Find the first element that matches the pattern and return the number after '[END]'
  for (const element of arr) {
    const match = element.match(regex);
    if (match) {
      return parseInt(match[1], 10); // Convert the matched number to an integer and return it
    }
  }

  // Return null if no match is found
  return null;
}

export function extractOpinion(code) {
  let opinion = "";

  // Check for the first format
  const opinionStart1 = "---\nOpinion:";
  const opinionIndex1 = code.indexOf(opinionStart1);
  if (opinionIndex1 !== -1) {
    opinion = code.substring(opinionIndex1 + opinionStart1.length).trim();
    return opinion;
  }

  // Check for the second format
  const opinionStart2 = "<opinion>";
  const opinionEnd2 = "</opinion>";
  const opinionIndex2 = code.indexOf(opinionStart2);
  const opinionEndIndex2 = code.indexOf(opinionEnd2);
  if (opinionIndex2 !== -1 && opinionEndIndex2 !== -1) {
    opinion = code
      .substring(opinionIndex2 + opinionStart2.length, opinionEndIndex2)
      .trim();
    return opinion;
  }

  return opinion;
}

import { History } from "../../Components/AppGenerator/history/history_types";

export const generateWaitingMessageAppGen = async (
  agentTrait: string,
  userInput?: string,
  history: History = [],
  onDataReceived
) => {
  const url = "https://api.openai.com/v1/chat/completions";

  const initialMessage = {
    role: "system",
    content: ` You are a generally intelligent & conscious digital clone created by the engineers of Orbofi, with the following traits: ${agentTrait}.
               The user has just asked you to generate a website prototype, and you are currently working on it. Please tell them to wait in a funny and unique way.
               When giving feedback or opinion, do not return any code, and do not suggest design changes or improvements.
              Just provide your opinion on the current prototype based on the given history and prompt.
              PLEASE KEEP IT SHORT, AND DONT MENTION THAT YOU CANNOT CODE`,
  };

  const historyMessages =
    history.length > 0
      ? history.map((item) => {
          if (item.type === "ai_create") {
            return {
              role: "user",
              content: `The website was initially created with the following input: ${
                item.inputs.text || item.inputs.image_url
              }.`,
            };
          } else {
            return {
              role: "user",
              content: `The website was updated with the following input: ${item.inputs.prompt}.`,
            };
          }
        })
      : [];

  const userMessage = {
    role: "user",
    content: `The user has now requested: "${userInput}". Please provide your opinion or feedback on the prototype without including any code or suggesting design changes.`,
  };

  const messages = [initialMessage, ...historyMessages, userMessage];

  const payload = {
    model: "gpt-4-turbo",
    messages: messages,
    temperature: 0.75,
    top_p: 0.95,
    // max_tokens: 60,
    stream: true,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${import.meta.env.VITE_OPENAI_API_KEY}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Stream handling
    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let result = "";
    let done = false;

    while (!done) {
      const { value, done: streamDone } = await reader.read();
      done = streamDone;
      result += decoder.decode(value, { stream: true });

      const lines = result.split("\n").filter((line) => line.trim() !== "");
      for (const line of lines) {
        if (line.startsWith("data: ")) {
          const jsonString = line.replace(/^data: /, "");
          if (jsonString === "[DONE]") {
            return;
          }
          try {
            const json = JSON.parse(jsonString);
            const content = json.choices[0].delta.content;
            onDataReceived(content); // Call the callback function with the streaming content
          } catch (err) {
            console.error("Failed to parse JSON:", err);
          }
        }
      }
    }
  } catch (error) {
    console.error("Error generating waiting message:", error);
    throw error; // Re-throw the error after logging it
  }
};

import { v4 as uuidv4 } from "uuid";
import { toast } from "react-hot-toast";

export const getVoiceForMessage = async (
  message,
  audioRef,
  setLoading,
  selectedVoice,
  chatbotData,
  setAudioSrc,
  setTalkingState,
  RUNPOD_BASE_URL
) => {
  const audioElement = audioRef.current;
  if (!audioElement) return;

  const onError = () => {
    setLoading(false);
    setTalkingState("idle");
    toast.error("Error loading audio, browser not supported");
  };

  try {
    const myUUID = uuidv4();
    const searchParams = new URLSearchParams();
    searchParams.set("prompt", message);
    searchParams.set("responseId", myUUID);
    searchParams.set("selectedVoice", selectedVoice);
    searchParams.set("introMsg", "false");
    searchParams.set("chatId", chatbotData.id);
    searchParams.set("isRAG", chatbotData.rag);

    setAudioSrc(`${RUNPOD_BASE_URL}/say-prompt?${searchParams.toString()}`);
    setLoading(true);

    audioElement.load();
    audioElement.onplay = () => {
      setTalkingState("talking");
    };

    const playAudio = () => {
      audioElement.play();
      setLoading(false);
    };

    audioElement.addEventListener("loadeddata", playAudio);
    audioElement.addEventListener("error", onError);

    return () => {
      audioElement.removeEventListener("loadeddata", playAudio);
      audioElement.removeEventListener("error", onError);
    };
  } catch (error) {
    onError();
  }
};

import axios from "axios";
import React from "react";

export async function describeImageForAppGen(params, apiKey) {
  if (params.inputType === "image") {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `${apiKey}`,
    };

    const payload = {
      model: "gpt-4o",
      messages: [
        {
          role: "user",
          content: [
            {
              type: "text",
              text: "The user is trying to create a prototype of this image into a prototype, can you give a short ONE LINE description of what it is",
            },
            {
              type: "image_url",
              image_url: {
                url: `${params.image}`,
              },
            },
          ],
        },
      ],
      max_tokens: 300,
    };

    try {
      return axios
        .post("https://api.openai.com/v1/chat/completions", payload, {
          headers,
        })
        .then((response) => {
          return response.data.choices[0].message.content;
        });
    } catch (error) {
      console.error("Error making API request:", error);
    }
  } else {
    console.log("Input type is not image.");
  }
}

export function useChatScroll<T>(
  dep: T
): React.MutableRefObject<HTMLDivElement> {
  const ref = React.useRef<HTMLDivElement>();
  React.useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [dep]);
  return ref;
}

import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";

// Initialize the S3 client with your configuration
const s3Client = new S3Client({
  region: import.meta.env.VITE_BEZOS_REGION,
  credentials: {
    accessKeyId: import.meta.env.VITE_BEZOS_ACCESS_KEY_ID,
    secretAccessKey: import.meta.env.VITE_BEZOS_SECRET_ACCESS_KEY,
  },
});

export async function uploadImageToS3(file: any): Promise<string> {
  // console.log("File object at start of uploadImageToS3:", file);

  try {
    // Construct the parameters for the upload
    const uploadParams = {
      Bucket: import.meta.env.VITE_BEZOS_BUCKET_NAME,
      Key: `uploads/${Date.now()}-${file.name}`,
      Body: file, // File content
      //ACL: 'public-read', // Uncomment if you need the file to be publicly readable
    };

    // Create a command to put the object in S3
    const uploadCommand = new PutObjectCommand(uploadParams);

    // Sending the command to S3
    const data = await s3Client.send(uploadCommand);
    // console.log('Successfully uploaded file.', data);

    // Assuming the return of the URL might need constructing
    const locationUrl = `https://${uploadParams.Bucket}.s3.${
      import.meta.env.VITE_BEZOS_REGION
    }.amazonaws.com/${uploadParams.Key}`;

    // console.log("locationUrl", locationUrl)
    return locationUrl;
  } catch (error: any) {
    console.error("Error uploading file:", error);
    throw new Error(error.message);
  }
}

export async function generateCodeOnly(prompt, setPartialCode, history) {
  const apiKey = import.meta.env.VITE_OPENAI_API_KEY;
  const endpoint = "https://api.openai.com/v1/chat/completions";

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: apiKey,
      },
      body: JSON.stringify({
        model: "gpt-4-turbo",
        messages: [
          {
            role: "system",
            content:
              "You are an expert assistant that generates code snippets based on user input. ALWAYS return only the code without any surrounding text, explanations, or triple backticks. DO NOT INCLUDE any comments or additional information, just the raw code.",
          },
          ...(history ? [{ role: "user", content: history }] : []),
          { role: "user", content: prompt },
        ],
        max_tokens: 3000,
        temperature: 0.5,
        stream: true,
      }),
    });

    if (!response.body) {
      throw new Error("No response body");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let fullResponse = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n");

      for (const line of lines) {
        if (line.startsWith("data: ")) {
          const jsonString = line.slice(6).trim();
          if (jsonString === "[DONE]") {
            return fullResponse;
          }

          try {
            const jsonChunk = JSON.parse(jsonString);
            if (jsonChunk.choices && jsonChunk.choices.length > 0) {
              const deltaContent = jsonChunk.choices[0].delta.content || "";
              fullResponse += deltaContent;

              // Strip any unwanted text, explanations, or triple backticks
              const cleanedResponse = fullResponse.replace(/```/g, "").trim();

              // Update the code progressively and set state
              setPartialCode(cleanedResponse);
            }
          } catch (e) {
            console.error("Error parsing JSON:", e);
          }
        }
      }
    }

    return fullResponse;
  } catch (error) {
    console.error("Error generating code:", error);
    return null;
  }
}

// export  const renderLoadingIndicators = () => {
//     let indicators = [];
//     for (let i = 0; i < 4; i++)
//     {
//         indicators.push(
//             <div key={i} style={{
//                 backgroundColor: "#38418b", // This sets a dark background color
//                 borderRadius: "5%", // This makes the border circular
//                 width: "125px", height: "125px", margin: "5px",
//                 display: "flex", // Use flex to center the CircularProgress
//                 justifyContent: "center", // Center horizontally
//                 alignItems: "center" // Center vertically
//             }}>
//                 {/* <CircularProgress /> */}
//                 <CircularProgressbar value={60} />
//             </div>
//         );
//     }
//     return indicators;
// };

// export const streamTextGeneration = async ({
//     message,
//     chatHistory,
//     setChatHistory,
//     openAIChatHistory,
//     setOpenAIChatHistory,
//     setIsTyping,
//     setIsLoading,
//     setIsProgressing,
//     setIsGenerating,
//     setTimerRunning,
//     resultRef,
//     refArray,
//     chatFieldRef,
//     addMessageToChat, // Ensure this is defined somewhere and imported
//     scrollToBottom, // This should be a function passed in that handles scrolling
//   }) => {

//     console.log('Starting')
//     if (message.length < 1)
//     {
//         toast.error("Make sure input text is greater than 1 character", {
//             icon: "👏",
//             style: {
//                 borderRadius: "10px",
//                 background: "#333",
//                 color: "#fff",
//                 // position: "bottom-center",
//                 // index: '1'
//             },
//         });
//         return;

//     }

//     const newChatHistory = [
//         ...chatHistory,
//         {
//             text: message,
//             sender: "user",
//             profile: "/images/profile.png",
//             // profile: userData?.ProfilePicture ?? "/images/profile.png",
//             audioUrl: "",
//         },
//     ];
//     setChatHistory(newChatHistory as []);

//     const openAIChatHistory2 = [
//         ...openAIChatHistory,
//         {
//             text: message,
//             sender: "user",
//             profile: "/images/profile.png",
//             audioUrl: "",
//         },
//     ];

//     setOpenAIChatHistory(openAIChatHistory2 as []);

//     currChatHistory = newChatHistory;
//     // numSentence = 0;
//     isSkipped = false;
//     setIsTyping(true);
//     setIsLoading(true);
//     setIsProgressing(true);
//     setIsGenerating((t) => true);

//     isAudioFinished = false;
//     setTimerRunning(true);
//     audioVideoQueue = {};
//     // scrollToBottom();
//     const AUDIO_ORBOX_QUANTITY = 1;
//     const VIDEO_QUANTITY_MULTIPLIER = 4;

//     needToShowAnswer = false;
//     hasShownResponse= false;

//     let audioBlobs = [];

//     // console.log("User wants to Generate Image.");
//     // setselectedAvatarURL(activeImage);

//     // setResultt("");

//     let audioQueue = []; // Initialize an empty queue for audio blobs
//     let isAudioPlaying = false; // A flag to track if audio is currently playing

//     function playBlob(blob: Blob | MediaSource) {
//         isAudioPlaying = true; // Immediately set the flag when starting to play a blob

//         return new Promise((resolve, reject) => {
//             const url = URL.createObjectURL(blob);
//             const audio = new Audio(url);

//             const cleanupAndResolve = () => {
//                 URL.revokeObjectURL(url);
//                 isAudioPlaying = false; // Reset flag when audio ends or errors
//                 // resolve();
//             };

//             audio.addEventListener('ended', cleanupAndResolve);
//             audio.addEventListener('error', () => {
//                 console.error(`Error playing audio`);
//                 cleanupAndResolve(); // Cleanup and resolve even in case of error
//             });

//             audio.play().catch(e => {
//                 console.error(`Error playing audio: ${e}`);
//                 cleanupAndResolve(); // Ensure cleanup even if play fails
//             });
//         });
//     }

//     console.log("CHAT HISTORY IS NOW");
//     console.log(openAIChatHistory2);
//     // console.log(convertMessages(openAIChatHistory2));

//     if (containsImageRequest(message))
//     {
//         console.log("User wants to Generate Image.");

//         let url = "https://api.openai.com/v1/chat/completions";
//         let tmp = {
//             model: "gpt-3.5-turbo",
//             messages: convertMessagesForImageGeneration(newChatHistory),
//             temperature: 0.75,
//             top_p: 0.95,
//             // max_tokens: 100,
//             stream: true,
//             // n: 1,
//         };

//         let source = new SSE(url, {
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: "Bearer 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",
//             },
//             method: "POST",
//             payload: JSON.stringify(tmp),
//         });

//         const newChatMessage: ChatMessage = {
//             text: (refIndex ).toString(),
//             sender: "system",
//             profile:"https://storage.googleapis.com/factories_orbofi/test/photo_2023-09-28_15-45-31.jpg", // Replace with actual data
//             audioUrl: "", // Replace with actual data
//             // images: [],
//             time: formatTime(new Date()),
//         };
//         addMessageToChat(newChatMessage);
//         var full_text = "";

//         source.addEventListener("message", (e:any) => {
//             setIsRunning(true);
//             scrollToBottom();

//             if (e.data != "[DONE]")
//             {

//                 setIsTyping(false);
//                 // setIsTyping(false);
//                 let payload = JSON.parse(e.data);
//                 // console.log(payload['choices']);
//                 let text = payload.choices[0].delta["content"];
//                 if (text != null)
//                 {
//                     full_text = full_text+ text;
//                     // console.log("Text: " + text);
//                     resultRef.current = resultRef.current + text;
//                     refArray[refIndex].current = refArray[refIndex].current + text;
//                     // setResultt(resultRef.current);

//                 }

//             } else
//             {
//                 // setResultt(resultRef.current);
//                 source.close();
//             }

//         });
//         // setGeneratedImageUrlsChatbot([]);
//         // setImagesStatus(["loading", "loading", "loading", "loading"]);
//         let hasRun = false;
//         source.addEventListener("readystatechange", async (e:any) => {
//             if (hasRun) return;
//             if (e.readyState >= 2)
//             {

//                 hasRun = true;
//                 setOpenAIChatHistory([
//                     ...newChatHistory,
//                     {
//                         text: full_text,
//                         sender: "system",
//                         profile: "/images/profile.png", //
//                         audioUrl: "", //
//                     },
//                 ] as never);
//                 // console.log("COMPLETED");
//                 // setIsTyping(false);
//                 scrollToBottom();
//                 hasRun = true;
//                 // isAudioFinished = true;
//                 console.log("FINISHED, INCREMENTING REF INDEX");
//                 refIndex += 1;

//                 setOpenAIChatHistory([
//                     ...newChatHistory,
//                     {
//                         text: full_text,
//                         sender: "system",
//                         profile: "/images/profile.png", //
//                         audioUrl: "", //

//                     },
//                 ] as never);

//                 var prompts = extractListItems(full_text);
//                 console.log(prompts);
//                 var images = [];

//                 Promise.all(prompts.map((prompt:string) => {
//                     const postData = {
//                         model: "dall-e-3",
//                         prompt: prompt,
//                         n: 1,
//                         size: "1024x1024"
//                     };

//                     return axios.post("https://api.openai.com/v1/images/generations", postData, {
//                         headers: {
//                             "Content-Type": "application/json",
//                             "Authorization": "Bearer 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"
//                         }
//                     })
//                         .then(response => {
//                             // Process each response
//                             console.log(response.data.data[0].url);
//                             images.push(response.data.data[0].url);
//                             // setImagesStatus(prevStatus => {
//                             //     const newStatus = [...prevStatus];
//                             //     newStatus[i] = "loaded";
//                             //     return newStatus;
//                             // });
//                         })
//                         .catch(error => {
//                             // Handle errors
//                             console.error("Error generating image for prompt:", prompt, error);
//                             setIsLoading(false);
//                         });
//                 }))
//                     .then(async ([imageResponses]) => {
//                         // This part runs after all promises have resolved
//                         // console.log("OUTPUT DATA");
//                         // console.log(voiceCloneResponse);
//                         console.log(imageResponses);
//                         const newChatMessage: ChatMessage = {
//                             text: "",
//                             sender: "system",
//                             profile:"https://storage.googleapis.com/factories_orbofi/test/photo_2023-09-28_15-45-31.jpg", // Replace with actual data
//                             audioUrl: "", // Replace with actual data
//                             images: images,
//                             time: formatTime(new Date()),
//                         };
//                         addMessageToChat(newChatMessage);
//                         // setChatHistory([
//                         //     ...newChatHistory,
//                         //     {
//                         //         text: resultRef.current,
//                         //         sender: "system",
//                         //         profile: activeImage, //
//                         //         audioUrl: "", //
//                         //         images: images.slice(0, 4),
//                         //     },
//                         // ]);

//                         // setIsRunning(false);
//                         // setIsProgressing(false);
//                         // setIsLoading(false);
//                         // setUrl(voiceCloneResponse);
//                     })
//                     .catch(error => {
//                         // Handle any error from the entire Promise.all
//                         console.error("Error in Promise.all:", error);
//                         setIsLoading(false);
//                     });

//             }
//         });

//     } else {

//     // console.log(convertMessagesForImageGeneration(newChatHistory));
//     let url = "https://api.openai.com/v1/chat/completions";
//     let tmp = {
//         model: "gpt-3.5-turbo",
//         messages: convertMessages(openAIChatHistory2),
//         temperature: 0.35,
//         // top_p: 0.95,
//         // max_tokens: 100,
//         stream: true,
//         // n: 1,
//     };

//     let source = new SSE(url, {
//         headers: {
//             "Content-Type": "application/json",
//             Authorization: "Bearer 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",
//         },
//         method: "POST",
//         payload: JSON.stringify(tmp),
//     });

//     let wordBuffer: any[] = [];

//     const newChatMessage: ChatMessage = {
//       text: (refIndex ).toString(),
//       sender: "system",
//       profile:"https://storage.googleapis.com/factories_orbofi/test/photo_2023-09-28_15-45-31.jpg", // Replace with actual data
//       audioUrl: "", // Replace with actual data
//       time: formatTime(new Date()),
//   };
//   addMessageToChat(newChatMessage);

//     var full_text = "";
//     console.log("Audio generation selected");
//     source.addEventListener("message", (e: { data: string; }) => {
//         setIsRunning(true);

//         // scrollToBottom();
//         if (e.data != "[DONE]")
//         {
//             // scrollToBottom();
//             // setIsTyping(false);
//             let payload = JSON.parse(e.data);
//             let text = payload.choices[0].delta["content"];
//             if (text != null)
//             {
//               scrollToBottom();
//                 // console.log("Text: " + text);
//                 full_text = full_text+ text;
//                 resultRef.current = resultRef.current + text;
//                 refArray[refIndex].current = refArray[refIndex].current + text;
//                 console.log(`Ref Array is: ${refArray[refIndex].current}`)
//                 // console.log("CURRENT REFERENCE IS");
//                 console.log(refArray[refIndex].current);

//                 // wordBuffer.push(text);
//                 var textTosay = "";
//                 textTosay = replaceHtmlCharsWithDot(full_text);
//                 textTosay = replaceSpecialCharsWithDot(textTosay);

//                 if(textTosay.endsWith(".")){
//                   let sentences = textTosay.split(".");
//                   console.log("SPLIT SENTENCES ARE: ");
//                   sentences = sentences.filter(element => element !== "");
//                   console.log(sentences);
//                   let lastSentence = sentences[sentences.length - 1];

//                   console.log("LAST SENTENCE TO GENERATE IS: ");
//                   console.log(lastSentence);
//                   const startTime = Date.now(); // Capture start time

//                   const startTimeId = startTime + "AUDIO";

//                   audioVideoQueue[startTimeId] =  {
//                           audio_data: null,
//                           isReady: false,
//                   }

//                   console.log("Generating Speech");

//                   // // Generate and play speech for the chunk
//                   generateSpeech(lastSentence).then((blob: any) => {
//                       console.log("Speech generation successful! Blob received:", blob);
//                       // Create a FormData object to hold the blob
//                       if(!isSkipped) {
//                           audioVideoQueue[startTimeId].isReady = true;
//                           audioVideoQueue[startTimeId].audio_data = blob;
//                           // index += 1;
//                           needToShowAnswer = true;

//                           // console.log(audioVideoQueue);
//                       }

//                   })
//                       .catch((error: any) => {
//                           console.error("Failed to generate s peech", error);

//                       });
//                 }

//                 // if (wordBuffer.length === 20)
//                 // { // Once the buffer has 6 words, generate speech
//                 //     let textChunk = wordBuffer.join(" "); // Join all words into a single string
//                 //     wordBuffer = []; // Clear the buffer for the next set of words

//                 //     textChunk = textChunk.replace(/ (?=[^\s])/g, '');

//                     // const startTime = Date.now(); // Capture start time

//                     // const startTimeId = startTime + "AUDIO";

//                     // audioVideoQueue[startTimeId] =  {
//                     //         audio_data: null,
//                     //         isReady: false,
//                     // }

//                     // console.log("Generating Speech");

//                     // // // Generate and play speech for the chunk
//                     // generateSpeech(textChunk).then((blob: any) => {
//                     //     console.log("Speech generation successful! Blob received:", blob);
//                     //     // Create a FormData object to hold the blob
//                     //     if(!isSkipped) {
//                     //         audioVideoQueue[startTimeId].isReady = true;
//                     //         audioVideoQueue[startTimeId].audio_data = blob;
//                     //         // index += 1;
//                     //         needToShowAnswer = true;

//                     //         // console.log(audioVideoQueue);
//                     //     }

//                     // })
//                     //     .catch((error: any) => {
//                     //         console.error("Failed to generate s peech", error);

//                     //     });
//                 // }
//             }
//         } else
//         {
//             if (wordBuffer.length > 0)
//             {
//                 const startTime = Date.now(); // Capture start time
//                 const startTimeId = startTime + "AUDIO";

//                 audioVideoQueue[startTimeId] =  {
//                         audio_data: null,
//                         isReady: false,
//                 }

//                 let remainingText = wordBuffer.join(" ");
//                 remainingText = remainingText.replace('"', " ");

//                 // resultRef.current = resultRef.current + remainingText;
//                 remainingText = remainingText.replace(/ (?=[^\s])/g, '');
//                 // console.log("Processing final chunk:", remainingText); // Log for debugging
//                 wordBuffer = []; // Clear the buffer

//                 console.log("Generating Speech");

//                 generateSpeech(remainingText).then((blob: any) => {
//                     if(!isSkipped) {
//                         audioVideoQueue[startTimeId].isReady = true;
//                         audioVideoQueue[startTimeId].audio_data = blob;
//                         // index += 1;
//                         needToShowAnswer = true;
//                         console.log(audioVideoQueue);
//                     }
//                 }).catch((error: any) => {
//                     console.error("Failed to generate speech for final chunk", error);
//                 });
//             }
//             setIsRunning(false);
//             source.close();
//         }

//     });

//     let hasRun = false;

//     source.addEventListener("readystatechange", (e: { readyState: number; }) => {
//         if (!hasRun && e.readyState >= 2)
//         {
//           scrollToBottom();
//             hasRun = true;
//             isAudioFinished = true;
//             console.log("FINISHED, INCREMENTING REF INDEX");
//               refIndex += 1;

//             setOpenAIChatHistory([
//                 ...newChatHistory,
//                 {
//                     text: full_text,
//                     sender: "system",
//                     profile: "/images/profile.png", //
//                     audioUrl: "", //
//                 },
//             ] as never);

//             // console.log(openAIChatHistory);

//         }
//     });
//     source.stream();

// }
//   };
